import React, { memo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';

function Row({
  row, actions, active, getControlTP,
}) {
  return (
    <TableRow
      key={row.id}
      onClick={(e) => actions.onActivateRow(e, row.id)}
      selected={active}
      hover
    >
      <TableCell>
        {getControlTP('datefrom', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('law_person_value_1', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('individual_value_1', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('law_person_value_2', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('individual_value_2', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('law_person_value_3', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('individual_value_3', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('law_person_value_4', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('individual_value_4', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('locality', row.id)}
      </TableCell>
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    datefrom: PropTypes.string,
    individual_value_1: PropTypes.number,
    individual_value_2: PropTypes.number,
    individual_value_3: PropTypes.number,
    individual_value_4: PropTypes.number,
    law_person_value_1: PropTypes.number,
    law_person_value_2: PropTypes.number,
    law_person_value_3: PropTypes.number,
    law_person_value_4: PropTypes.number,
    locality: PropTypes.shape({ id: PropTypes.number, repr: PropTypes.string }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  active: PropTypes.bool,
  getControlTP: PropTypes.func.isRequired,
};

Row.defaultProps = {
  active: false,
};

export default memo(Row);
